import React from 'react';
import { Redirect } from 'react-router-dom';
export function UiRouterRedirect(_a) {
    var to = _a.to, params = _a.params;
    return (React.createElement(Redirect, { to: Object.keys(params || {}).reduce(function (path, key) { return path.replace(":" + key, params === null || params === void 0 ? void 0 : params[key]); }, to) }));
}
